import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';

const FinancePage: React.FC = () => {
  useEffect(() => {
    // Inject ConvertKit script for finance page form
    const script = document.createElement('script');
    script.src = 'https://fullness-life.kit.com/e923a152bb/index.js';
    script.async = true;
    script.setAttribute('data-uid', 'e923a152bb');
    document.getElementById('ck_embed_form_finance')?.appendChild(script);
    return () => {
      document.getElementById('ck_embed_form_finance')?.removeChild(script);
    };
  }, []);

  return (
    <div className="bg-black text-white min-h-screen" style={{ 
      fontFamily: "'-apple-system', 'BlinkMacSystemFont', 'SF Pro Display', 'SF Pro Text', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
    }}>
      <Navbar />

      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes wireframeShift {
            0% {
              background-position: 0 0, 0 0, 0 0, 0 0;
            }
            100% {
              background-position: 12px 12px, 12px 12px, 8px 8px, -8px 8px;
            }
          }
          
          @keyframes pulseCorner {
            0%, 100% {
              opacity: 0.3;
              transform: scale(1);
            }
            50% {
              opacity: 0.8;
              transform: scale(1.1);
            }
          }
          
          @keyframes textGlow {
            0%, 100% {
              text-shadow: 
                0 0 2px #f5f5dc,
                0 0 4px rgba(245, 245, 220, 0.8),
                0 0 6px rgba(245, 245, 220, 0.6);
            }
            50% {
              text-shadow: 
                0 0 4px #f5f5dc,
                0 0 8px rgba(245, 245, 220, 0.9),
                0 0 12px rgba(245, 245, 220, 0.7);
            }
          }

          /* ConvertKit Form Styles */
          .ck-form * {
            box-sizing: border-box;
          }
          
          .ck-form {
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            max-width: 500px;
            margin: 0 auto;
          }
          
          .ck-form .ck-fields {
            display: flex;
            flex-wrap: wrap;
            gap: 15px;
            margin-bottom: 20px;
          }
          
          .ck-form .ck-field {
            flex: 1;
            min-width: 200px;
          }
          
          .ck-form .ck-input {
            width: 100%;
            background: rgba(255, 255, 255, 0.95);
            font-size: 15px;
            padding: 12px 16px;
            border: 1px solid rgba(245, 245, 220, 0.3);
            border-radius: 4px;
            font-weight: 700;
            color: #000;
            transition: all 0.3s ease;
            font-family: inherit;
          }
          
          .ck-form .ck-input:focus {
            outline: none;
            border-color: #f5f5dc;
            box-shadow: 0 0 0 2px rgba(245, 245, 220, 0.2);
            background: #ffffff;
          }
          
          .ck-form .ck-input::placeholder {
            color: rgba(0, 0, 0, 0.6);
            opacity: 1;
          }
          
          .ck-form .ck-submit {
            background-color: #f5f5dc;
            color: #000;
            border: none;
            border-radius: 4px;
            font-weight: 600;
            font-size: 15px;
            padding: 12px 24px;
            cursor: pointer;
            transition: all 0.3s ease;
            width: 100%;
            font-family: inherit;
            letter-spacing: 0.02em;
          }
          
          .ck-form .ck-submit:hover {
            background-color: #e6e6cd;
            transform: translateY(-2px);
            box-shadow: 0 4px 16px rgba(245, 245, 220, 0.3);
          }
          
          .ck-form .ck-powered-by {
            text-align: center;
            margin-top: 15px;
          }
          
          .ck-form .ck-powered-by a {
            color: rgba(245, 245, 220, 0.6);
            text-decoration: none;
            font-size: 12px;
            transition: color 0.3s ease;
          }
          
          .ck-form .ck-powered-by a:hover {
            color: rgba(245, 245, 220, 0.8);
          }

          @media (max-width: 640px) {
            .ck-form .ck-fields {
              flex-direction: column;
            }
            
            .ck-form .ck-field {
              min-width: auto;
            }
          }
        `
      }} />

      {/* Hero Section */}
      <section style={{ 
        minHeight: '80vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        textAlign: 'center', 
        background: '#1A252F',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Wireframe grid background */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
          backgroundImage: `
            linear-gradient(rgba(245, 245, 220, 0.15) 0.5px, transparent 0.5px),
            linear-gradient(90deg, rgba(245, 245, 220, 0.15) 0.5px, transparent 0.5px),
            linear-gradient(45deg, rgba(245, 245, 220, 0.08) 0.5px, transparent 0.5px),
            linear-gradient(-45deg, rgba(245, 245, 220, 0.08) 0.5px, transparent 0.5px)
          `,
          backgroundSize: '12px 12px, 12px 12px, 8px 8px, 8px 8px',
          animation: 'wireframeShift 8s linear infinite',
          opacity: 0.6
        }}></div>
        
        <div style={{ 
          maxWidth: '1200px', 
          margin: '0 auto', 
          padding: '0 2rem',
          position: 'relative',
          zIndex: 2
        }}>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <h1 style={{ 
              fontSize: 'clamp(2.5rem, 6vw, 4rem)', 
              fontWeight: '500', 
              letterSpacing: '0.02em', 
              marginBottom: '1rem',
              lineHeight: '1.1',
              color: '#f5f5dc',
              textShadow: `
                0 0 1px #f5f5dc,
                0 0 3px rgba(245, 245, 220, 0.6),
                0 0 5px rgba(245, 245, 220, 0.4)
              `,
              position: 'relative',
              zIndex: 2,
              filter: 'drop-shadow(0 0 6px rgba(245, 245, 220, 0.2))'
            }}>
              Numbers Game
            </h1>
            
            {/* Corner accent lines */}
            <div style={{
              position: 'absolute',
              top: '10%',
              left: '5%',
              width: '15px',
              height: '15px',
              border: '1px solid rgba(245, 245, 220, 0.4)',
              borderRight: 'none',
              borderBottom: 'none',
              animation: 'pulseCorner 3s ease-in-out infinite'
            }}></div>
            <div style={{
              position: 'absolute',
              bottom: '10%',
              right: '5%',
              width: '15px',
              height: '15px',
              border: '1px solid rgba(245, 245, 220, 0.4)',
              borderLeft: 'none',
              borderTop: 'none',
              animation: 'pulseCorner 3s ease-in-out infinite 1.5s'
            }}></div>
          </div>
          
          <p style={{ 
            fontSize: 'clamp(1.2rem, 3vw, 1.8rem)', 
            marginBottom: '2rem', 
            opacity: 0.9, 
            fontWeight: '300',
            color: 'rgba(245, 245, 220, 0.8)',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            From Struggling Student to Building Wealth
          </p>
          
          <div style={{ 
            fontSize: '1.1rem', 
            maxWidth: '800px', 
            margin: '0 auto 3rem', 
            opacity: 0.9, 
            lineHeight: 1.7,
            textAlign: 'left'
          }}>
            <p style={{ marginBottom: '1.5rem' }}>
              I started as a struggling student in Miami, barely scraping by. My journey took me to London where I began studying money habits and financial strategies. Now I'm in the UAE, actively building my wealth while learning and applying both modern and traditional approaches.
            </p>
            
            <p style={{ marginBottom: '1.5rem' }}>
              Having experienced three different financial ecosystems firsthand, I'm discovering that the path from financial struggle to stability isn't about luck or connections – it's about having the right blueprint and making informed decisions.
            </p>
            
            <p style={{ marginBottom: '1.5rem', fontWeight: '600', color: '#f5f5dc' }}>
              This isn't theory from someone who's never faced financial challenges. These are methods I'm actively using and refining as I navigate my own financial journey across three continents.
            </p>
            
            <p style={{ marginBottom: '1.5rem' }}>
              I'm exploring modern wealth creation and preservation techniques that work in today's economy – from strategic investments and international optimization to AI-powered income streams. I'm learning that the old principles provide a foundation, while adopting new approaches to build wealth.
            </p>
            
            <p style={{ fontWeight: '600', color: '#f5f5dc' }}>
              Join me on this journey. Let's learn as we build the financial future we envision, step by step.
            </p>
          </div>
          
          <div style={{ 
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            marginBottom: '4rem'
          }} id="ck_embed_form_finance"></div>
        </div>
      </section>

      {/* Problem/Solution Framework */}
      <section style={{ padding: '6rem 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
          <h2 style={{ 
            fontSize: 'clamp(2rem, 4vw, 3rem)', 
            fontWeight: 500, 
            textAlign: 'center', 
            marginBottom: '3rem',
            color: '#f5f5dc',
            textShadow: '0 0 10px rgba(245, 245, 220, 0.2)'
          }}>
            Why Traditional Financial Advice Fails Millennials
          </h2>
          <div style={{ background: '#111', border: '1px solid #333', padding: '3rem', margin: '2rem 0', textAlign: 'center' }}>
            <h3>The Problem:</h3>
            <p>Most financial advice was written for people who bought houses for £50,000 and went to university for £1,000. That's not your reality.</p>
            
            <h3>The Real Cost of Financial Stress:</h3>
            <ul style={{ textAlign: 'left', maxWidth: '600px', margin: '2rem auto' }}>
              <li>🧠 <strong>Mental Health:</strong> 76% of millennials lose sleep over money</li>
              <li>💔 <strong>Relationships:</strong> Money fights are the #1 cause of breakups</li>
              <li>🚀 <strong>Career:</strong> Financial stress kills risk-taking and growth</li>
              <li>⏰ <strong>Time:</strong> Years wasted worrying instead of building knowledge and applying it</li>
            </ul>

            <h3>What They Don't Teach You:</h3>
            <p>Building wealth isn't about deprivation - it's about optimization. I live in UAE, and travel the world. The difference? I invest in assets before appearances.</p>
          </div>
        </div>
      </section>

      {/* The Method */}
      <section style={{ padding: '6rem 0', background: '#0a0a0a' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
          <h2 style={{ 
            fontSize: 'clamp(2rem, 4vw, 3rem)', 
            fontWeight: 500, 
            textAlign: 'center', 
            marginBottom: '3rem',
            color: '#f5f5dc',
            textShadow: '0 0 10px rgba(245, 245, 220, 0.2)'
          }}>
            The 4-Pillar Wealth System
          </h2>
          <p style={{ textAlign: 'center', marginBottom: '3rem', fontSize: '1.2rem' }}>
            The exact framework I used to build wealth in my 20s
          </p>
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
            gap: '2rem', 
            margin: '3rem 0' 
          }}>
            <div style={{ background: '#1a1a1a', border: '1px solid #333', padding: '2rem', textAlign: 'center', transition: 'all 0.3s ease' }}>
              <h3 style={{ color: '#f5f5dc', fontSize: '1.5rem', marginBottom: '1rem' }}>1. Emergency Fund (Security)</h3>
              <p>£1,000 minimum buffer so you never go backwards. This isn't about being scared - it's about being strategic.</p>
            </div>
            <div style={{ background: '#1a1a1a', border: '1px solid #333', padding: '2rem', textAlign: 'center', transition: 'all 0.3s ease' }}>
              <h3 style={{ color: '#f5f5dc', fontSize: '1.5rem', marginBottom: '1rem' }}>2. Debt Elimination (Freedom)</h3>
              <p>Kill high-interest debt first. Every pound in interest you pay is a pound that can't compound for you.</p>
            </div>
            <div style={{ background: '#1a1a1a', border: '1px solid #333', padding: '2rem', textAlign: 'center', transition: 'all 0.3s ease' }}>
              <h3 style={{ color: '#f5f5dc', fontSize: '1.5rem', marginBottom: '1rem' }}>3. Investment Portfolio (Growth)</h3>
              <p>Index funds, ETFs, and strategic investments. Let your money work harder than you do.</p>
            </div>
            <div style={{ background: '#1a1a1a', border: '1px solid #333', padding: '2rem', textAlign: 'center', transition: 'all 0.3s ease' }}>
              <h3 style={{ color: '#f5f5dc', fontSize: '1.5rem', marginBottom: '1rem' }}>4. Income Optimization (Acceleration)</h3>
              <p>Salary negotiation, side hustles, and AI tools to multiply your earning potential.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Offerings */}
      <section style={{ padding: '6rem 0' }} id="start">
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
          <h2 style={{ 
            fontSize: 'clamp(2rem, 4vw, 3rem)', 
            fontWeight: 500, 
            textAlign: 'center', 
            marginBottom: '3rem',
            color: '#f5f5dc',
            textShadow: '0 0 10px rgba(245, 245, 220, 0.2)'
          }}>
            Start Your Financial Transformation
          </h2>
          
          <h3 style={{ textAlign: 'center', margin: '3rem 0 2rem', color: '#4CAF50' }}>FREE Resources (Start Here)</h3>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', 
            gap: '2rem', 
            margin: '3rem 0' 
          }}>
            {[
              {
                title: "£1K Emergency Fund Blueprint",
                description: "Generate £1K alongside your current life",
                tag: "FREE",
                color: "#4CAF50"
              },
              {
                title: "5 Wealth Principles That Changed My Life",
                description: "The mindset shifts that took me from London to Abu Dhabi",
                tag: "FREE",
                color: "#4CAF50"
              },
              {
                title: "The Beginner's Guide to Index Fund Investing",
                description: "Build wealth with simple index fund strategies",
                tag: "FREE",
                color: "#4CAF50"
              }
            ].map((item, index) => (
              <div key={index} style={{ 
                background: '#1a1a1a', 
                border: '1px solid #333', 
                padding: '2rem', 
                textAlign: 'center', 
                position: 'relative', 
                overflow: 'hidden',
                borderColor: item.color
              }}>
                <div style={{
                  position: 'absolute',
                  top: '1rem',
                  right: '1rem',
                  background: item.color,
                  color: 'white',
                  padding: '0.5rem 1rem',
                  fontWeight: 600,
                  fontSize: '0.9rem'
                }}>
                  {item.tag}
                </div>
                <h3 style={{ fontSize: '1.4rem', marginBottom: '1rem', color: '#f5f5dc' }}>{item.title}</h3>
                <p style={{ marginBottom: '2rem', opacity: 0.8 }}>{item.description}</p>
                <a 
                  href="#ck_embed_form_finance" 
                  onClick={e => {
                    e.preventDefault();
                    const form = document.getElementById('ck_embed_form_finance');
                    let target: HTMLElement | null = form;
                    if (form) {
                      // Try to find the first input (first name field)
                      const input = form.querySelector('input[type="text"]');
                      if (input) target = input as HTMLElement;
                      if (target) {
                        const y = target.getBoundingClientRect().top + window.pageYOffset - 40; // 40px offset for nav
                        window.scrollTo({ top: y, behavior: 'smooth' });
                      }
                    }
                  }}
                  style={{
                    background: '#f5f5dc',
                    color: '#000',
                    border: 'none',
                    padding: '1.25rem 3rem',
                    fontSize: '1rem',
                    fontWeight: 600,
                    cursor: 'pointer',
                    letterSpacing: '0.02em',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 16px rgba(245, 245, 220, 0.2)',
                    textDecoration: 'none',
                    display: 'inline-block'
                  }}
                >
                  SIGN UP TO RECEIVE
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section style={{ background: 'linear-gradient(135deg, #1a1a1a 0%, #000 100%)', padding: '6rem 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem', textAlign: 'center' }}>
          <h2 style={{ 
            fontSize: 'clamp(2rem, 4vw, 3rem)', 
            fontWeight: 500, 
            marginBottom: '2rem',
            color: '#f5f5dc'
          }}>
            Ready to Master Your Financial Edge?
          </h2>
          <p style={{ fontSize: '1.3rem', margin: '2rem auto', maxWidth: '600px' }}>
            Stop letting money stress control your life. Start building the wealth and freedom you deserve.
          </p>
          
          <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', flexWrap: 'wrap', margin: '3rem 0' }}>
            <a href="#start" style={{
              background: '#f5f5dc',
              color: '#000',
              border: 'none',
              padding: '1.25rem 3rem',
              fontSize: '1rem',
              fontWeight: 600,
              cursor: 'pointer',
              letterSpacing: '0.02em',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 16px rgba(245, 245, 220, 0.2)',
              textDecoration: 'none',
              display: 'inline-block'
            }}>
              START WITH FREE RESOURCES
            </a>
            {/* <a href="#" style={{
              background: 'transparent',
              border: '2px solid #f5f5dc',
              color: '#f5f5dc',
              padding: '1.25rem 3rem',
              fontSize: '1rem',
              fontWeight: 600,
              cursor: 'pointer',
              letterSpacing: '0.02em',
              transition: 'all 0.3s ease',
              textDecoration: 'none',
              display: 'inline-block'
            }}>
              DOWNLOAD FREE GUIDES
            </a> */}
          </div>
          
          {/* <p style={{ marginTop: '2rem', opacity: 0.8 }}>
            Join 15,000+ people building wealth with Fullness Life
          </p> */}
        </div>
      </section>
    </div>
  );
};

export default FinancePage;